import React from 'react';
import { Citation } from '../../types/educational-chat';
import { BookOpenIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

interface CitationCardProps {
  citation: Citation;
  index: number;
  onClick?: () => void;
}

export const CitationCard: React.FC<CitationCardProps> = ({
  citation,
  index,
  onClick
}) => {
  return (
    <div
      className="citation-card"
      onClick={onClick}
      style={{
        padding: '12px',
        backgroundColor: '#F9FAFB',
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        display: 'flex',
        gap: '12px',
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.backgroundColor = '#F3F4F6';
          e.currentTarget.style.borderColor = '#9CA3AF';
          e.currentTarget.style.transform = 'translateX(4px)';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.backgroundColor = '#F9FAFB';
          e.currentTarget.style.borderColor = '#E5E7EB';
          e.currentTarget.style.transform = 'translateX(0)';
        }
      }}
    >
      <div
        className="citation-index"
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          backgroundColor: '#E0E7FF',
          color: '#4F46E5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          fontWeight: '600',
          flexShrink: 0,
        }}
      >
        {index}
      </div>

      <div className="citation-content flex-1">
        <div className="citation-header flex items-center gap-2 mb-1">
          <BookOpenIcon className="w-4 h-4 text-indigo-600" />
          <span className="text-sm font-medium text-gray-900">
            {citation.book_title || 'Source'} - Page {citation.page_number}
          </span>
          {citation.chapter_title && (
            <span className="text-xs text-gray-500">
              • {citation.chapter_title}
            </span>
          )}
        </div>

        <p className="citation-excerpt text-sm text-gray-600 leading-relaxed mb-2">
          "{citation.excerpt}"
        </p>

        {citation.relevance_score && (
          <div className="citation-relevance flex items-center gap-2">
            <span className="text-xs text-gray-500">Relevance:</span>
            <div className="relevance-bar" style={{ width: '60px', height: '4px', backgroundColor: '#E5E7EB', borderRadius: '2px', overflow: 'hidden' }}>
              <div
                style={{
                  width: `${citation.relevance_score * 100}%`,
                  height: '100%',
                  backgroundColor: citation.relevance_score > 0.7 ? '#10B981' : citation.relevance_score > 0.4 ? '#F59E0B' : '#6B7280',
                  transition: 'width 0.3s ease'
                }}
              />
            </div>
            <span className="text-xs text-gray-500">
              {Math.round(citation.relevance_score * 100)}%
            </span>
          </div>
        )}

        {onClick && (
          <button
            className="citation-action flex items-center gap-1 mt-2 text-xs text-indigo-600 hover:text-indigo-800 font-medium"
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
          >
            <span>Jump to page</span>
            <ArrowTopRightOnSquareIcon className="w-3 h-3" />
          </button>
        )}
      </div>
    </div>
  );
};

export default CitationCard;